<template>
	<div :id="this.id" class="web-content" :class="this.footer ? 'web-content-footer': '' ">
		<h3 v-if="this.webContent?.header && this.header == true">{{ this.webContent?.header }}</h3>
		<p v-html="this.webContent?.html"></p>
		<b v-if="!this.webContent">
			<Circle v-if="this.spinner" fileName="spinner" :color=" this.footer ? '' : '--grey-5'" :spinning="true" :title="this.name" />
		</b>
	</div>
</template>
<script>

import { webContentMixin } from "@/mixins/webContentMixin.js";

export default {
	name: "WebContent",
	components: {},
	mixins: [webContentMixin],
	props: {
		name: String,
		header:{
			type: Boolean,
			default: false
		},
		footer: {
			type: Boolean,
			default: false
		},
		spinner:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {

		};
	},
	computed: {

		webContent(){
			return this.webContentHTML(this.name);
		},

		id(){
			var string = "web-content-";
			string += "" + this.name?.toLowerCase()?.replace(" ", "-");
			return "" + string
		}


	},
	
	methods: {
		
	},
	
};
</script>

<style scoped>
html body div#app div.web-content.web-content-footer h3,
html body div#app div.web-content.web-content-footer p
{
	color: white;
}

</style>